import React from 'react';
import AdminDataTable from '../AdminDataTable';

const BlankTable = ({ title, columns, data, style, actions, options, localization }) => {
    return (
        <AdminDataTable
            title={title}
            columns={columns}
            data={data}
            style={style}
            actions={actions}
            options={{ ...options,}}
            localization={localization}
        />

    )
}

export default BlankTable;
